<template>
<v-container fluid class="pa-0">
    <PageHeader :contextStyle="contextStyle" >
        <template #right><v-btn small rounded color="primary" :to="{ name: 'teams-edit', params: { id: 0 } }">Ajouter une équipe</v-btn></template>
    </PageHeader>

    <TeamsForm v-if="( $route.params.id !== undefined && parseInt( $route.params.id ) >= 0 )"/>
    <v-card v-else class="ma-4 rounded-lg">
        <TeamsList />
    </v-card>
</v-container>
</template>

<script>
import PageHeader from '@/components/ui/PageHeader'
import TeamsList from '@/components/teams/TeamsList'
import TeamsForm from '@/components/teams/TeamsForm'

export default {
    name: 'team-page',
    components: { PageHeader, TeamsList, TeamsForm },
    props: ['contextStyle'],
    data () {
        return { }
    },
    methods: {

    }
}
</script>

<style lang="css">

</style>
